import { CompanyRole } from '@types';
import { useGetOGPUserInfo } from 'ogp/hooks';
import { hasAccessWithinPolicyGroup, PolicyGroups } from 'shared/utils/policy-controller';

export const useIsOgpAdmin = () => {
  const userQuery = useGetOGPUserInfo();

  const isOgpAdmin =
    userQuery.data &&
    hasAccessWithinPolicyGroup(PolicyGroups.COMPANY, userQuery.data.userInfo, CompanyRole.ADMIN);
  return isOgpAdmin ?? false;
};
